import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import * as moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { ClassificacaoStore } from "../../stores/classificacao/ClassificacaoStore";
import { Tag } from "@blueprintjs/core";
import { toast } from "react-toastify";
import { ICalc } from "../../model";
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Typography } from "@mui/material";
import { AppIcon } from "../utils/AppIcon";

const numeral = require("numeral");

interface ClassificacaoItensDetailProps {
  items: any[];
}

interface ClassificacaoItensDetailState { }

@observer
export class ClassificacaoItensDetail
  extends React.Component<ClassificacaoItensDetailProps, ClassificacaoItensDetailState> {
  obs: any = observable({})

  constructor(props) {
    super(props);
  }

  async handleClassificar(item: any, estadual: boolean, classificacao: string) {

    let calc_id = null

    if (classificacao == "REVENDA") {

      await ClassificacaoStore.classificacao_revenda([item.id], ClassificacaoStore.obs.selectedEmpresa.cnpj)

    } else {

      let calcs = await ClassificacaoStore.loadCalcs();

      const calcEncontrado = ClassificacaoStore.handleBuscaCalculo(calcs, estadual, classificacao)

      if (calcEncontrado) {

        calc_id = calcEncontrado._id;

      } else {

        toast.error("Nenhum Cálculo encotrado, contate o suporte!", {});
        return

      }

      let params = {
        nota_item_ids: [item.id],
        contestacao_data: null,
        motivo: `Classificação de itens para ${classificacao}`,
        contestacao_calc_id: calc_id,
        entrada_saida: "entrada",
        modelo: "nf-e",
      }

      await ClassificacaoStore.create_classificacao_task(params, ClassificacaoStore.obs.selectedEmpresa.uf, classificacao)

    }

  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  onSelectAll = async (isSelect, rows) => {
    if (isSelect) {
      let data = rows?.map(value => {
        return {
          id: value.id,
          uf_destino: value.uf_destino,
          uf_origem: value.uf_origem
        }
      })
      ClassificacaoStore.setClassificarItemsList(data);
    } else {
      ClassificacaoStore.resetClassificarItems();
    }
  };

  onSelect = async (item, checked) => {
    let data = {
      id: item.id,
      uf_destino: item.uf_destino,
      uf_origem: item.uf_origem
    }
    if (checked) {
      ClassificacaoStore.setClassificarItems(data);
    } else {
      ClassificacaoStore.deleteByIdClassificarItems(item.id);
    }
  }

  public render() {

    const items_new = this.props.items?.map((item: any) => {

      return ({
        id: item.id,
        any_item: item,
        dhrecbto: item.dhrecbto,
        serie_nota: item.serie_nota + " / " + (item.num_nota ? item.num_nota : ""),
        num_item: item.num_item,
        data: item.data,
        data_calculo: item.data_calculo,
        descricao: item.descricao.substring(0, 40).toUpperCase(),
        valor_produto: numeral(parseFloat(item.valor_produto)).format("$ 0,0.00"),
        contestar: item,
        chave_nota: item.chave_nota,
        cfop: item.cfop,
        estadual: item.uf_origem == item.uf_destino,
        classificacao: item.classificacao_cliente_final
      });

    });

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      onSelectAll: this.onSelectAll,
      columnWidth: "40px",
      onSelect: this.onSelect,
      selected: ClassificacaoStore.obs.classificarItems?.map(value => value.id),
      unselectable: ClassificacaoStore.obs.itens_processando,
    };

    function buttonFormatterData(cell, row) {
      return (
        <>
          {moment(cell).format("DD/MM/YYYY")} - {moment(row.data_calculo).add(3, "hours").format("HH:mm")}
        </>
      );
    };

    const ClassificacaoCell = ({ row, handleClassificar }) => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const [query, setQuery] = React.useState("");
      const inputRef = React.useRef(null);

      const open = Boolean(anchorEl);

      const color: string =
        row.classificacao == "REVENDA" ? "#1F77B4"
        : row.classificacao == "USO E CONSUMO" ? "#2CA02C"
        : row.classificacao == "ATIVO IMOBILIZADO" ? "#D62728"
        : row.classificacao == "TRANSFERÊNCIA" ? "#9467BD"
        : row.classificacao == "CONSERTO" ? "#FF7F0E"
        : row.classificacao == "COMODATO" ? "#E377C2"
        : row.classificacao == "COMBUSTÍVEL USO" ? "#BCBD22"
        : row.classificacao == "COMBUSTÍVEL REVENDA" ? "#0F766E"
        : row.classificacao == "SERVIÇO" ? "#17BECF"
        : row.classificacao == "INDUSTRIALIZAÇÃO" ? "#8C564B"
        : row.classificacao == "ESTOQUE" ? "#4d4d4d"
        : row.classificacao == "BONIFICAÇÃO" ? "#00A6FB"
        : row.classificacao == "MERCADORIA" ? "#3A0CA3"
        : row.classificacao == "GARANTIA" ? "#00B894"
        : row.classificacao == "FUTURA" ? "#c78e06"
        : row.classificacao == "DEVOLUÇÃO" ? "#C1121F"
        : row.classificacao == "OUTRAS ENTRADAS" ? "#475569"
        : row.classificacao == "DEMONSTRAÇÃO" ? "#7C3AED"
        : row.classificacao == "CONSIGNAÇÃO" ? "#B45309"
        : "none";

      const background: string =
        row.classificacao == "REVENDA" ? "rgba(19, 124, 189, 0.15)"
        : row.classificacao == "USO E CONSUMO" ? "rgba(15, 153, 96, 0.15)"
        : row.classificacao == "ATIVO IMOBILIZADO" ? "rgba(219, 55, 55, 0.15)"
        : row.classificacao == "TRANSFERÊNCIA" ? "rgba(148, 103, 189, 0.21)"
        : row.classificacao == "CONSERTO" ? "rgba(255, 127, 14, 0.18)"
        : row.classificacao == "COMODATO" ? "rgba(143, 57, 143, 0.15)"
        : row.classificacao == "COMBUSTÍVEL USO" ? "rgba(188, 189, 34, 0.18)"
        : row.classificacao == "COMBUSTÍVEL REVENDA" ? "rgba(15, 118, 110, 0.16)"
        : row.classificacao == "SERVIÇO" ? "rgba(23, 190, 207, 0.15)"
        : row.classificacao == "INDUSTRIALIZAÇÃO" ? "rgba(140, 86, 75, 0.29)"
        : row.classificacao == "ESTOQUE" ? "rgba(77, 77, 77, 0.23)"
        : row.classificacao == "BONIFICAÇÃO" ? "rgba(0, 166, 251, 0.09)"
        : row.classificacao == "MERCADORIA" ? "rgba(58, 12, 163, 0.2)"
        : row.classificacao == "GARANTIA" ? "rgba(15, 153, 96, 0.15)"
        : row.classificacao == "FUTURA" ? "rgba(255, 179, 0, 0.21)"
        : row.classificacao == "DEVOLUÇÃO" ? "rgba(193, 18, 31, 0.14)"
        : row.classificacao == "OUTRAS ENTRADAS" ? "rgba(71, 85, 105, 0.14)"
        : row.classificacao == "DEMONSTRAÇÃO" ? "rgba(124, 58, 237, 0.14)"
        : row.classificacao == "CONSIGNAÇÃO" ? "rgba(180, 83, 9, 0.14)"
        : "none";

      const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setQuery("");
      };

      const handleClose = () => setAnchorEl(null);

      const handleSelect = (id) => {
        handleClassificar(row.any_item, row.estadual, id)
        handleClose();
      };

      React.useEffect(() => {
        if (open) setTimeout(() => inputRef.current?.focus(), 0);
      }, [open]);

      const filtered = React.useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return ClassificacaoStore.options();
        return ClassificacaoStore.options().filter((o) => o.name.toLowerCase().includes(q));
      }, [query]);

      return (
        <div>
          {ClassificacaoStore.obs.itens_processando.indexOf(row.id) !== -1 ? (
            <Tag style={{ textAlign: "center", cursor: "pointer", fontSize: 11, paddingRight: 8, paddingLeft: 8, paddingTop: 6, paddingBottom: 6 }} round intent="primary">
              PROCESSANDO . . .
            </Tag>
          ) : (
            <Tag
              style={{ textAlign: "center", cursor: "pointer", fontSize: 11, color: color, backgroundColor: background, borderColor: color }}
              round
              minimal={true}
              onClick={handleOpen}
              rightIcon={<AppIcon name="keyboard_arrow_down" />}
            >
              {row.classificacao}
            </Tag>
          )}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            disableAutoFocusItem
            sx={{ zIndex: 10000 }}
          >
            <Box>
              <TextField
                inputRef={inputRef}
                size="small"
                fullWidth
                placeholder="Buscar classificação…"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Escape") handleClose();
                }}
              />
            </Box>

            <Divider />

            <Box sx={{ maxHeight: 300, overflow: "auto", py: 0.5 }}>
              {filtered.length === 0 ? (
                <Typography variant="body2" sx={{ p: 2, opacity: 0.75 }}>
                  Nenhum resultado para “{query}”.
                </Typography>
              ) : (
                filtered.map((x) => (
                  <MenuItem key={x.id || x.name} onClick={() => handleSelect(x.id)} dense>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <AppIcon name={x.icon || "help"} color="#000" />
                    </ListItemIcon>

                    <ListItemText
                      primary={x.name}
                      primaryTypographyProps={{ noWrap: true, title: x.name }}
                    />
                  </MenuItem>
                )))}
            </Box>
          </Menu>
        </div>
      );
    };

    return (
      <>
        <BootstrapTable data={items_new} selectRow={selectRowProp} tableHeaderClass="align-middle" tableBodyClass="align-middle">
          <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
          <TableHeaderColumn dataField="serie_nota" width="15%">Série / Nota</TableHeaderColumn>
          <TableHeaderColumn dataField="num_item" width="10%">Nº Item</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatterData} dataField="data" width="20%">Data de Emissão</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatterData} dataField="data_calculo" width="20%">Data do Cálculo</TableHeaderColumn>
          <TableHeaderColumn dataField="cfop" width="20%">CFOP</TableHeaderColumn>
          <TableHeaderColumn dataField="descricao" width="60%">Descrição</TableHeaderColumn>
          <TableHeaderColumn dataField="valor_produto" width="20%">Valor Produto</TableHeaderColumn>
          <TableHeaderColumn dataFormat={(cell, row) => (
            <ClassificacaoCell row={row} handleClassificar={this.handleClassificar.bind(this)} />
          )} width="40%">Classificar</TableHeaderColumn>
        </BootstrapTable>

      </>
    );
  }
}

export default ClassificacaoItensDetail;
